//     Init Drawer Component
//
//     Usage:
//     <w3-drawer></w3-drawer>

/* Get locale for endpoint */
const SHOPIFY_LOCALE = Shopify.locale == 'fr' ? '' : `/${Shopify.locale}`

/**
 * Generic drawer element
 */
export default class Drawer extends HTMLElement {
    constructor() {
        super();

        this.bindEvents = this.bindEvents.bind(this);
        this.openDrawer = this.openDrawer.bind(this);
        this.closeDrawer = this.closeDrawer.bind(this);
        this.onClickOutside = this.onClickOutside.bind(this);
        this.createCustomEvents = this.createCustomEvents.bind(this);
        this.onEchap = this.onEchap.bind(this);
    }

    connectedCallback() {
        this.Drawer = {};
        this.drawerEl = this;

        this.drawerSidebarEl = this.drawerEl.querySelector('.js-drawer-sidebar');
        this.drawerContentEl = this.drawerEl.querySelector('.js-drawer-content');
        this.handleTargetContent = this.drawerEl.dataset.contentFrom;
        this.drawerName = this.drawerEl.getAttribute('drawer-name') ? this.drawerEl.getAttribute('drawer-name') : 'drawer';

        this.isDrawerMobile = this.drawerEl.classList.contains('js-drawer--mobile');
        this.disableClickOutside = this.drawerEl.hasAttribute('disable-click-outside') || false ;

        this.isDrawerOpen = false;
        this.isAnyDrawerVisible = false;
        this.mobileBreakpoint = 1024;
        this.isMobile = window.matchMedia(`(max-width: ${this.mobileBreakpoint}px)`).matches;
        this.bodyTopPosition = 0;

        this.speed = parseInt(this.drawerEl.getAttribute('speed-transition')) || 200 ;

        this.customEvent = {};

        if (this.handleTargetContent) {
            this.getContent();
        }

        if (this.isDrawerMobile && !this.isMobile) return;

        this.createCustomEvents();
        this.bindEvents();
    }

    openDrawer() {
        if (this.isDrawerOpen) { return; }

        // very specific case if another drawer is already open
        if (document.body.classList.contains('drawer-visible')) {
            this.isAnyDrawerVisible = true;
        }

        if (this.drawerEl.getAttribute('closer')) {
            this.drawerBtnsClose = document.querySelectorAll(this.drawerEl.getAttribute('closer'));
        } else {
            this.drawerBtnsClose = this.drawerEl.querySelectorAll('.js-drawer-close');
        }
        for (const buttonClose of this.drawerBtnsClose) {
            buttonClose.addEventListener('click', this.closeDrawer)
        }

        document.body.classList.add('drawer-visible', `${this.drawerName}-visible`);

        setTimeout(() => {
            this.drawerEl.classList.add('drawer--visible');
        }, 50);

        setTimeout(() => {
            if (this.isMobile) {
                this.lockScroll();
            }

            this.isDrawerOpen = true;
            document.addEventListener('keyup', this.onEchap);
            document.addEventListener('click', this.onClickOutside);
            this.drawerEl.dispatchEvent(this.customEventDrawerOpen);
            window.lozadObserver.observe();
        }, this.speed)
    }

    lockScroll() {
        this.bodyTopPosition = document.documentElement.scrollTop;
        document.body.style.top = `-${this.bodyTopPosition}px`;
        document.documentElement.classList.add('lock-scroll');
    }

    unLockScroll() {
        document.documentElement.classList.remove('lock-scroll');
        window.scrollTo({ left: 0, top: this.bodyTopPosition, behavior: 'instant' });
        document.body.style.top = `unset`;
    }

    closeDrawer() {
        this.drawerEl.classList.add('drawer-transition-out');
        document.removeEventListener('keyup', this.onEchap);
        document.removeEventListener('click', this.onClickOutside);

        if (this.isMobile) {
            this.unLockScroll();
        }

        setTimeout(() => {
            this.isDrawerOpen = false;
            this.drawerEl.classList.remove('drawer--visible', 'drawer-transition-out');
            document.body.classList.remove(`${this.drawerName}-visible`);

            if (!this.isAnyDrawerVisible) {
                document.body.classList.remove('drawer-visible');
            }

            this.drawerEl.dispatchEvent(this.customEventDrawerClose);
        }, this.speed);
    }

    onEchap(e) {
        const keyCode = e.keyCode || e.which;

        if (keyCode === 27) {
            this.closeDrawer();
        }
    }

    onClickOutside(e) {
        if (this.disableClickOutside) { return; }

        const isClickedOutside = !this.drawerSidebarEl.contains(e.target);
        if (isClickedOutside) {
            this.closeDrawer();
        }
    }

    getContent() {
        const url = `${SHOPIFY_LOCALE}/pages/${this.handleTargetContent}.json`;
        fetch(url)
        .then(data => data.json())
        .then(data => {
            return data.page;
        })
        .then(content => {
            this.drawerContentEl.innerHTML = content.body_html.toString();
        })
    }

    createCustomEvents() {
        this.customEventDrawerOpen = new CustomEvent('drawer--open', {
            bubbles: true,
            cancelable: true,
            composed: false,
        });

        this.customEventDrawerClose = new CustomEvent('drawer--close', {
            bubbles: true,
            cancelable: true,
            composed: false,
        });
    }

    bindEvents() {
        if (this.drawerEl.getAttribute('opener')) {
            this.drawerBtnsOpen = document.querySelectorAll(this.drawerEl.getAttribute('opener'));
        }

        if (this.drawerBtnsOpen) {
            this.drawerBtnsOpen.forEach(drawerBtnOpen => {
                drawerBtnOpen.addEventListener('click', this.openDrawer)
            });
        }
    }

    disconnectedCallback() {
        if (this.drawerBtnsOpen) {
            this.drawerBtnsOpen.forEach(drawerBtnOpen => {
                drawerBtnOpen.removeEventListener('click', this.openDrawer)
            });
        }

        if (this.drawerBtnsClose !== undefined && this.drawerBtnsClose.length > 1) {
            this.drawerBtnsClose.forEach(button => {
                button.removeEventListener('click', this.closeDrawer)
            });
        }
    }
}

if (customElements.get('w3-drawer') === undefined) {
    customElements.define('w3-drawer', Drawer);
}

